export default __webpack_public_path__ + "static/media/1JulyLight.30c8d78c.svg";